// extracted by mini-css-extract-plugin
export default {"tooltip":"dV-z","arrow":"eV-z"};